import { truncate } from "@/modules/truncate";
import { NoteSuggestionData } from "@/store/note/types";

export const truncateSuggestionDataForTracking = (
  suggestionData?: NoteSuggestionData | null
): {
  previousMarkdownContents?: string;
  suggestedMarkdownContents?: string;
  transcriptText?: string;
  userPrompt?: string;
} => {
  if (!suggestionData) return {};

  const previousMarkdownContents = suggestionData.prev_markdown_content
    ? truncate(suggestionData.prev_markdown_content, 255)
    : undefined;
  const suggestedMarkdownContents = suggestionData.suggested_markdown_content
    ? truncate(suggestionData.suggested_markdown_content, 255)
    : undefined;
  const transcriptText =
    "transcript_text" in suggestionData.metadata && suggestionData.metadata.transcript_text
      ? truncate(suggestionData.metadata.transcript_text, 255)
      : undefined;
  const userPrompt =
    "user_prompt" in suggestionData.metadata && suggestionData.metadata.user_prompt
      ? truncate(suggestionData.metadata.user_prompt, 255)
      : undefined;

  return {
    previousMarkdownContents,
    suggestedMarkdownContents,
    transcriptText,
    userPrompt,
  };
};
